<div *ngIf="!accessible">
  <frg-cards class="not-accessible-container" [border]="false" title="DMP inaccessible">
    <div style="margin-left: 2.5rem; font-weight: 500; font-size: 1.5rem;">
      Vous n'avez pas les droits pour accéder au DMP de ce patient
    </div>
  </frg-cards>
</div>
<div class="margin-bottom" *ngIf="accessible">
  <!-- <div class="nav-bar" *ngIf="dmpAccessRight == 'authorized' || dmpAccessRight == 'unauthorized'">  -->
    <div class="nav-bar">
      <div class="nav-bar-item-wrapper">
        <div class="nav-bar-item" *ngIf="dmpAccessRight == 'authorized'" [ngClass]="{'active': currentDmpStep === dmpSteps.dmpAccessRight}" (click)="currentDmpStep = dmpSteps.dmpAccessRight">Consultation</div>
        <div class="nav-bar-item" *ngIf="dmpAccessRight == 'authorized' || dmpAccessRight == 'unauthorized'" [ngClass]="{'active': currentDmpStep === dmpSteps.myDocuments}" (click)="displayMyDocuments()">Documents Envoyés</div>
      </div>
    </div>
  <frg-cards class="antecedents-card" [border]="false" [title]="currentDmpStep ? currentDmpStep.title : 'DMP'"
    [subtitle]="cardSubtitle">
    <!-- Si aucune session CPX en cours -->
    <div class="no-session" *ngIf="!currentDmpStep || currentDmpStep === dmpSteps.myDocuments && dmpAccessRight == 'unknow'">
      <span *ngIf="!cpxCardInfosExists">Veuillez vous authentifier avec une carte CPX pour commencer.</span>

      <div class="button-container">
        <frg-button (activated)="initCpxSession()">
          <div title="S'authentifier" *ngIf="!cpxCardInfosExists">S'authentifier</div>
          <div title="Accéder au DMP" *ngIf="cpxCardInfosExists">Accéder au DMP</div>
        </frg-button>

        <span *ngIf="cpxCardInfosExists">
          <frg-button (activated)="openWebPsSpace()" *ngIf="currentDmpStep && currentDmpStep !== dmpSteps.myDocuments && cpxCardInfosExists">
            <div title="Accéder à l'espace Web PS">Accéder à l'espace Web PS</div>
          </frg-button>

          <frg-button (activated)="displayMyDocuments()" *ngIf="currentDmpStep && currentDmpStep !== dmpSteps.myDocuments && cpxCardInfosExists">
            <div title="Afficher les documents que j'ai envoyé" >Afficher les documents que j'ai envoyé</div>
          </frg-button>
        </span>
      </div>

    </div>

    <!-- Étape de recherche de patient -->
    <!-- <app-search-patient
      *ngIf="currentDmpStep === dmpSteps.findDmp"
      (selectPatient)="selectPatient($event)"
      [currentPatient]="patient"
      [currentPatientAddress]="patientAddress"
      [cpxSession]="cpxSession"
    ></app-search-patient> -->
    <!-- <div class="find-dmp-step">
      <div class="button-container" *ngIf="currentDmpStep === dmpSteps.findDmp">
        <frg-button (activated)="findDmp()">
          <div title="Rechercher un DMP">Rechercher un DMP</div>
        </frg-button>
      </div>
    </div> -->

    <!-- Étape de vérification et acquisition des droits d'accès au DMP -->
    <app-display-dmp
      *ngIf="currentDmpStep === dmpSteps.myDocuments || currentDmpStep === dmpSteps.dmpAccessRight"
      [currentDmpStep]="currentDmpStep"
      [dmp]="displayDmp"
      [isBrisDeGlace]="isBrisDeGlace"
      [isSecretMode]="isSecretMode"
      [amIMt]="amIMt"
      [cpxAccess]="connectionType"
      [accessRight]="dmpAccessRight"
      (endDisplayDmp)="endDisplayDmp()"
      (addDocumentToDmp)="addDocumentToDmp()"
      (changeAuthorization)="handleAccessRight(undefined, true)"
      [patientIns]="patientIns"
      [patientId]="patientId"
      [patientInsIdentity]="patientInsIdentity"
      [autorisationAlimentation]="autorisationAlimentation"
    ></app-display-dmp>

    <!-- Étape d'ajout de documents au DMP' -->
    <app-add-documents
      *ngIf="currentDmpStep === dmpSteps.addDocuments"
      [dmp]="displayDmp"
      [patientId]="patient.id"
      (endAddDocuments)="endAddDocuments()"
      [patientInsIdentity]="patientInsIdentity"
      [isBrisDeGlace]="isBrisDeGlace"
    ></app-add-documents>

    <!-- Liste des documents ajoutés par l'utilisateur (par RPPS) au DMP de ce patient -->
    <!-- <div class="search-result my-docs" *ngIf="currentDmpStep === dmpSteps.myDocuments">
      <div class="table-label">Mes documents ajoutés au DMP</div>
      <frg-table
        [keysBody]="myDocsTable"
        [keysColumn]="myDocsTableColumnTable"
        [tableButton1]="'assets/icons/trash.svg'"
        (onClick1)="deleteDocFromUser($event)"
        [tableButton1Tooltip]="'Supprimer le document'"
      ></frg-table>
    </div> -->
  </frg-cards>
</div>
